import { render, staticRenderFns } from "./PFSettlementAwaitingConsent.vue?vue&type=template&id=a59809ac"
import script from "./PFSettlementAwaitingConsent.vue?vue&type=script&lang=js"
export * from "./PFSettlementAwaitingConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports